import { render, staticRenderFns } from "./music_child.vue?vue&type=template&id=816201d0&scoped=true"
import script from "./music_child.vue?vue&type=script&lang=js"
export * from "./music_child.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816201d0",
  null
  
)

export default component.exports